import React, { Component } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import "./css/landing.css";

class PreviewOtherPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      templateData: null,
    };
  }

  componentDidMount() {
    const { match: { params } } = this.props;
    const { projectId } = params;

    axios
      .get(
        `https://rscoreapi.azurewebsites.net/api/ProjectLandingPage/byprojectguidpreview?guid=${projectId}`
      )
      .then((res) => {
        this.setState({ templateData: res.data });
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
      });
  }

  render() {
    const { templateData } = this.state;
    const templateCSS = templateData?.landingPageFullContent || "";
    const templateId = templateData?.landingPageTemplateId;
     const customCSSForTemplate8 = `
      #u_content_image_1 img{
      max-width: 100% !important;
      height: 80vh !important;
    }
     #u_column_1{
      flex: 0 0 54.77%;
      max-width: 54.77%;
     }
      #u_column_2{
        flex: 0 0 23.08%;
        max-width: 23.08%;
      }
     #u_column_8{
     margin-top: 20px !important;
    }
      #u_content_heading_3 h4{
        font-size: 16px !important;
        color: #fff !important;
        font-weight: bold !important;
      }
         #u_content_heading_2 h4{
        font-size: 16px !important;
        color: #fff !important;
        font-weight: bold !important;
      }
          #u_content_heading_1 h4{
        font-size: 16px !important;
        color: #fff !important;
        font-weight: bold !important;
      }
          #u_content_heading_4 h1{
        color: #fff !important;
        font-weight: bold !important;
      }
      #u_content_image_2 img{
      background-color: #fff !important;
      }
    `;
    const customCSSForTemplate11 = `
    #u_content_html_1 td{
      font-size: 16px !important;
      font-weight: bold !important;
    }
    #u_content_heading_3{
    padding:60px 10px 10px !important;
    }
    #u_content_heading_4 h2 {
      font-size: 18px !important;
    }
    #u_content_heading_6 h4 {
     font-size: 20px !important;
     font-weight:bold !important;
     padding-top:0px !important;
    }
    #u_content_text_5 h6{
      color:#fff !important;
    }
  `;

  const customCSSForTemplate7 = `
 #u_content_heading_1 h4{
    font-size: 16px !important;
    font-weight: bold !important;
    padding-top:0px !important
  }
    #u_content_heading_2 h4{
    font-size: 16px !important;
    font-weight: bold !important;
    padding-top:0px !important
  }
     #u_content_heading_3 h4{
    font-size: 16px !important;
    font-weight: bold !important;
    padding-top:0px !important
  }
  #u_content_heading_3{
  padding:11px 10px 10px !important;
  }
  #u_content_heading_4 h2 {
    font-size: 18px !important;
  }
  #u_content_heading_6 h4 {
   font-size: 20px !important;
   font-weight:bold !important;
   padding-top:0px !important;
  }
  #u_content_text_1 h6{
    color:#fff !important;
  }
  #u_content_heading_3{}
`;
const customCSSForTemplate5 = `
#u_content_html_4 img{
  height:175px !important;
  margin-bottom: 20px;
}
#u_content_heading_1 h4{
   font-size: 16px !important;
   font-weight: bold !important;
   padding-top:0px !important
 }
   #u_content_heading_2 h4{
   font-size: 16px !important;
   font-weight: bold !important;
   padding-top:0px !important
 }
    #u_content_heading_3 h4{
   font-size: 16px !important;
   font-weight: bold !important;
   padding-top:0px !important
 }
 #u_content_heading_3{
 padding:32px 10px 10px !important;
 }
 #u_content_heading_4 h2 {
   font-size: 18px !important;
 }
 #u_content_heading_6 h4 {
  font-size: 20px !important;
  font-weight:bold !important;
  padding-top:0px !important;
 }
#u_content_text_6 ul li{
  
      display: block !important;
      width:100% !important;
      margin-bottom:15px;
  
}
form button{
  background-color:#000 !important;
}
#u_content_heading_17 h1{ padding-left:2rem !important; }
 #u_content_text_1 h6{
   color:#fff !important;
 }
#u_content_heading_8 h4{ font-size:20px !important; font-weight:bold !important; padding-top: 0px;}
 #u_content_heading_10 h4{ font-size:20px !important; font-weight:bold !important; padding-top: 0px;}
  #u_content_heading_12 h4{ font-size:20px !important; font-weight:bold !important; padding-top: 0px;}
  #u_column_7{ 
  align-items: center;

  }
#u_column_18{  align-items: center; }
#u_column_21{  align-items: center; }
#u_content_heading_13 h1{font-size: 18px !important;}
`;
const customCSSForTemplate3 = `
#u_content_heading_1 h1{
font-size: 32px !important;
font-family: georgia !important;
color: #000 !important;
padding-top:43px;
}
#u_content_heading_2 h1{
  font-size: 32px !important;
font-family: georgia !important;
color: #000 !important;
}
#u_content_heading_3 h1{
  font-size: 32px !important;
font-family: georgia !important;
color: #000 !important;
}
 #u_content_heading_4 h1{
  font-size: 32px !important;
font-family: georgia !important;
color: #000 !important;
}
 
 #u_content_heading_5 h1{
  font-size: 32px !important;
  font-family: georgia !important;
  color: #000 !important;
}
 #u_content_heading_6 h1{
  font-size: 32px !important;
  font-family: georgia !important;
  color: #000 !important;
}
 #u_content_heading_7 h1{
  font-size: 32px !important;
  font-family: georgia !important;
  color: #000 !important;
}
 #u_content_heading_8 h1{
  font-size: 32px !important;
  font-family: georgia !important;
  color: #000 !important;
}
 #u_content_heading_9 h1{
  font-size: 32px !important;
  font-family: georgia !important;
  color: #000 !important;
  padding-top:200px;
}
 #u_content_html_3 img{
  width:24.6% !important;
  height:175px !important;
  margin-bottom: 20px;
  margin-right:5px
}
#u_content_html_2 table td{ font-size: 20px; font-weight:bold; color:#ed1c24}
`;
    return (
      <React.Fragment>
        <ToastContainer autoClose={2000} />
        <MetaTags>
          <title>Preview | Realty Space</title>
        </MetaTags>
        {templateId === 11 && (
          <style dangerouslySetInnerHTML={{ __html: customCSSForTemplate11 }} />
        )}
        {templateId === 7 && (
          <style dangerouslySetInnerHTML={{ __html: customCSSForTemplate7 }} />
        )}
         {templateId === 5 && (
          <style dangerouslySetInnerHTML={{ __html: customCSSForTemplate5 }} />
        )}
          {templateId === 3 && (
          <style dangerouslySetInnerHTML={{ __html: customCSSForTemplate3 }} />
        )}
          {templateId === 16 && (
          <style dangerouslySetInnerHTML={{ __html: customCSSForTemplate8 }} />
        )}
        <div
          dangerouslySetInnerHTML={{
            __html: templateCSS || "Loading content..."
          }}
        />
      </React.Fragment>
    );
  }
}

PreviewOtherPage.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  history: PropTypes.object
};

export default connect()(withTranslation()(PreviewOtherPage));
